import { doAdminMutation } from 'infrastructure/api'

export async function reIndexTrees(
  ...trees: { treeId: string; versionId: string }[]
) {
  const tree_ids = trees.map(
    ({ treeId, versionId }) => `${treeId}:${versionId}`,
  )
  const { data: result, errors } = await doAdminMutation(
    { key: 'reIndexTrees' },
    { tree_ids },
  )
  return { result, errors }
}
